module.exports = __webpack_public_path__ + "img/zidingyifenlei1.5047a866.png";